import axios from "axios";
import { environment } from "../../../environments/environment";
import { HTTP_RESPONSE_CODES } from "../../../globals/globals";

export function getCategorySections(categoryId) {
    return axios.get(`${environment.getCategorySections}?categoryId=${categoryId}`,);
}

export function getPartEff(partId) {
    return axios.post(`${environment.getPartEff}?page=0&pageSize=1000`, [{ columnName: "accountId", value: parseInt(localStorage.getItem('u_account_id')) },{columnName: "partId", value: partId}]);
}

export function savePartEffReq(eff) {
    if (typeof (eff.id) === "number") {
        return axios.put(`${environment.savePartEff}?partId=${eff.partId}`,
            { ...eff, accountId: parseInt(localStorage.getItem('u_account_id')) }
        )
    } else {
        return axios.post(`${environment.savePartEff}?partId=${eff.partId}`,
            { ...eff, accountId: parseInt(localStorage.getItem('u_account_id')) }
        ).then(response => {
            if (response.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
                return savePartEffReq({...eff, id:response.data.load.id});
            } else {
                return Promise.resolve(response);
            }
        })
    }
    // return axios.request({
    //     url: `${environment.savePartEff}?partId=${eff.partId}`,
    //     data: { ...eff, accountId: parseInt(localStorage.getItem('u_account_id')) },
    //     method: typeof (eff.id) === "number" ? "PUT" : "POST"
    // })
}

export function saveEffRanges(range) {
    return axios.post(`${environment.savePartEffRange}`, range);
}

export function saveEffManSelection(acArray) {
    return axios.post(`${environment.savePartEffSelection}`, acArray);
}

export function deleteManSelection(id) {
    return axios.delete(`${environment.deletePartEffSelection}?id=${id}`);
}

export function deletePartEff(id) {
    return axios.delete(`${environment.deletePartEff}?id=${id}`)
}

export function getManualSelection(effId) {
    return axios.get(`${environment.getEffSelection}?partEffectivityId=${effId}`)
}

export function getRangeSelection (effId){
    return axios.get(`${environment.getEffRanges}?partEffectivityId=${effId}`);
}

export function getAircrafts(accountFleetId) {
    return axios.post(`${environment.getDropdownData}`,
        {
            "id": 51,
            "search": "",
            "dependencies": [],
            "page": 0,
            "pageSize": 1000,
            "parentComponentId": null,
            "filters": [],
            "parameters": [
                {
                    "columnName": "accountId",
                    "value": parseInt(localStorage.getItem('u_account_id'))
                },
                {
                    "columnName": "seriesId",
                    "value": typeof (accountFleetId) === 'number' ? accountFleetId : null
                }
            ]
        }
    )
}